(function() {
  'use strict';

  angular.module('app').controller('FeedbackSourcesController', FeedbackSourcesController);

  FeedbackSourcesController.$inject = [
    '$rootScope',
    '$scope',
    '$routeParams',
    '$location',
    '$filter',
    '$timeout',
    'blockUI',
    'NewsService',
    'CouponsService',
    'LANGS',
    'SelectService',
    'SettingsService',
    'FeedbackService',
    'BusinessService',
    '$uibModal',
    'LoyaltyService'];

  function FeedbackSourcesController($rootScope, $scope, $routeParams, $location, $filter, $timeout,
      blockUI, NewsService, CouponsService, LANGS, SelectService, SettingsService, FeedbackService, BusinessService, $uibModal,
      LoyaltyService) {

    $scope.isPageMode = isPageMode;
    $scope.modals = {};
    $scope.multilangPublicTitle = MultilanguageHelper();
    $scope.multilangInvitationText = MultilanguageHelper();
    $scope.initLocaleStrings = initLocaleStrings;
    $scope.doShow = _doShow;

    $scope.getFiltersList = SelectService.getLList;

    $scope.model = {};

    $scope.data = {
      rewardTypes: [
        {title: 'none', value: 'none'},
        {title: 'regular-bonuses reward', value: 'regular-bonuses'},
        {title: 'promotional-bonuses reward', value: 'promotional-bonuses'},
        {title: 'special-account reward', value: 'special-account'},
        {title: 'coupon reward', value: 'coupon'}
      ],
      bonusesExpireTypes: [
        {title: 'TEXT_BONUS_POINTS_BEGINNING_TYPE_VALUE_DATE', value: 'date'},
        {title: 'TEXT_BONUS_POINTS_BEGINNING_TYPE_VALUE_DAYS', value: 'day'},
        {title: 'TEXT_BONUS_POINTS_BEGINNING_TYPE_VALUE_MONTH', value: 'month'}
      ]
    };
    $scope.data.possibleCustomerActions = FeedbackService.possibleCustomerActions;

    var block_feedbackSources_list = blockUI.instances.get('block_feedbackSources_list');
    var feedbackSources_edit = blockUI.instances.get('feedbackSources_edit');

    var canCreateSource = $rootScope.ENV.business.tariff && $rootScope.ENV.business.tariff.month_feedback_sources_price === 0
        && $rootScope.ENV.business.tariff.free_feedback_sources_count <= $rootScope.ENV.business.status.customer_feedback_sources_count;
    $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
    SettingsService.GetPlatformSupportedLanguages(function(success, response) {
      $scope.platformSupportedLanguagesCodes = response;
    });
    initController();

    function isPageMode(mode) {
      return mode == $scope._pageMode;
    }

    function isRouteMode(mode) {
      return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
    }

    function initPageMode() {
      $scope._pageMode = 'show';

      if (isRouteMode('edit')) {
        $scope._pageMode = ($routeParams.hasOwnProperty('feedbackSourceId')) ? 'edit' : 'show';
      } else if (isRouteMode('create')) {
        $scope._pageMode = 'create';
      }

      getSpecialAccountsList();
      getLoyaltyList();
      initCurrencyList();

      switch ($scope._pageMode) {
        case 'show':
          _doShow();
          break;
        case 'create':
          _doCreate();
          break;
        case 'edit':
          _doEdit();
          break;
      }
    }

    function _doEdit() {
      feedbackSources_edit.start();
      getCouponBatches($rootScope.ENV.filters.feedback_source.filter.id);
      FeedbackService.getFeedbackSourceData($routeParams.loyalty_id || $rootScope.ENV.filters.feedback_source.filter.id,
          $routeParams.feedbackSourceId, function(success, data) {
            if (success) {
              $scope.model.feedbackSource = data;
              $scope.initLocaleStrings($scope.model.feedbackSource);
            } else {
              $location.path('/feedback/sources');
            }
            feedbackSources_edit.stop();
          });
    }

    function initController() {
      $scope.multilangPublicTitle.initLangs(LANGS, $rootScope.LANG);
      $scope.multilangInvitationText.initLangs(LANGS, $rootScope.LANG);
      initPageMode();
    }

    /**
     * Init loyalty string
     */
    function initLocaleStrings(new_feedback_source) {
      $scope.multilangPublicTitle.initStrings(new_feedback_source, ['public_title']);
      $scope.multilangInvitationText.initStrings(new_feedback_source, ['invitation_text']);
    }

    /**
     * Event receive when change editing language
     */
    $scope.onChangeLanguagePublicTitle = function(new_lang) {
      $scope.multilangPublicTitle.selected(new_lang);
    };

    $scope.onChangeLanguageInvitationText = function(new_lang) {
      $scope.multilangInvitationText.selected(new_lang);
    };

    $scope.onFeedbackSourceToggleClick = function(feedbackSource) {
      block_feedbackSources_list.start();
      var post_data = {
        id: feedbackSource.id,
        active: 1 * !Boolean(feedbackSource.active),
        title: feedbackSource.title
      };

      FeedbackService.changeFeedbackSource($rootScope.ENV.filters.feedback_source.filter.id, feedbackSource.id, post_data,
          function(success, data) {
            block_feedbackSources_list.stop();
            getFeedbackSources($rootScope.ENV.filters.feedback_source.filter.id);
          });
    };

    function _doShow() {
      block_feedbackSources_list.start();
      if ($scope.data.currentFilter) {
        getFeedbackSources($scope.data.currentFilter.id);
      } else {
        block_feedbackSources_list.stop();
      }
    }

    function initCurrencyList() {
      var currency;
      var cl = {};

      cl['EUR'] = 'EUR';
      cl['USD'] = 'USD';

      $scope.data.currencyList = [];
      for (var i in cl)
        $scope.data.currencyList.push({id: i, title: i});

      BusinessService.CurrencyList(undefined, function(success, response) {
        if (success) {
          for (var i in response) {
            if (response[i] !== cl['EUR'] && response[i] !== cl['USD']) {
              $scope.data.currencyList.push({id: response[i], title: response[i]});
            }

          }
        }
      });
    }

    function getCouponBatches(loyaltyId, times) {
      var params = {
        loyalty: loyaltyId,
        only_active: true,
        page: 1 * (times ? times : 1),
        count: 20
      };
      CouponsService.Batches(params, function(success, data) {
        if (success) {
          $scope.couponBatchList = !$scope.couponBatchList ? data.data : $scope.couponBatchList.concat(data.data);
          if (data.summary.total_rows_count > (params.page * params.count)) {
            getCouponBatches(loyaltyId, times ? times + 1 : 2);
          }
        }
      });
    }

    function getLoyaltyList() {
      LoyaltyService.All(function(success, response) {
        if (success) {
          $scope.data.loyaltyList = response;
        }
      });
    }

    function getFeedbackSources(loyalty_id) {
      FeedbackService.getFeedbackSources(loyalty_id, {
        page: 1,
        count: 20,
        only_active: !$scope.data.only_active
      }, function(success, response) {
        console.log('getFeedbackSources', response);
        if (success) {
          $scope.data.feedbackSourcesList = angular.copy(response.data);
        }
        block_feedbackSources_list.stop();
      });
    }

    $scope.updateFeedbackSourcesList = function() {
      getFeedbackSources($rootScope.ENV.filters.feedback_source.filter.id);
    };

    function getSpecialAccountsList() {
      BusinessService.SpecialAccounts(function(success, response) {
        if (success) {
          $scope.data.specialAccountsList = response;
        }
      });
    }

    /* NEW FEEDBACK SOURCE CREATION METHODS*/

    function _doCreate() {
      if (canCreateSource) {
        openCannotCreateModal(function() {
          $location.path('/feedback/sources');
        });
      } else {
        $scope.model.new_feedbackSource = {
          active: 1,
          created: moment().utc().toDate(),
          reward_type: 'none'
        };

        $scope.model.feedbackSource = angular.copy($scope.model.new_feedbackSource);
        $scope.model.feedbackSource.customer_actions = 'rate-and-review';

        $scope.initLocaleStrings($scope.model.feedbackSource);
        getCouponBatches($rootScope.ENV.filters.feedback_source.filter.id);
      }
    }

    $scope.onFeedbackSourceSave = function(form, closeOnSave) {
      if (isRouteMode('edit')) {
        FeedbackService.changeFeedbackSource(this.model.feedbackSource.loyalty_id, this.model.feedbackSource.id, this.model.feedbackSource,
            function(success, response) {
              if (closeOnSave && success) {
                $scope.onCancelEdit();
              }
            });
      } else {
        FeedbackService.addFeedbackSource($rootScope.ENV.filters.feedback_source.filter.id, this.model.feedbackSource,
            function(success, response) {
              if (closeOnSave && success) {
                $scope.onCancelEdit();
              }
            });
      }

    };

    $scope.onCancelEdit = function() {
      $location.path('/feedback/sources');
      _doShow();
    };

    function setDefaultLanguage(country) {
      var lang = $rootScope.LANG;
      if (country)
        if (country === 'UA')
          return 'uk';
        else if (country === 'RU')
          return 'ru';
        else if (country === 'PL')
          return 'pl';
        else if (lang === 'ru')
          return 'ru';
        else
          return 'en';
      else
        return 'en';
    }

    $scope.isLoyaltyActive = function(loyalty_id) {
      var loyalty = null;
      var pos = null;

      if ($rootScope.LOYALTIES) {
        loyalty = itemByIndex($rootScope.LOYALTIES, loyalty_id);
        return loyalty && loyalty.active;
      }
      return false;
    };

    $scope.onShowQR = function(feedbackSource) {
      block_feedbackSources_list.start();

      FeedbackService.getFeedbackSourceData(feedbackSource.loyalty_id, feedbackSource.id, function(success, data) {
        block_feedbackSources_list.stop();
        if (success) {
          openModal(data.urls.short_url);
        }
      });
    };

    function openModal(url) {
      $scope.modals.FeedbackSources = $uibModal.open({
        animation: true,
        keyboard: true,
        size: 'md',
        templateUrl: 'app/templates/modal.register.link.html',
        controllerAs: 'popup',
        controller: function($uibModalInstance) {
          var popup = this;
          popup.model = {
            link: url
          };
          popup.onPrint = function() {
            var printContents = document.getElementById('printable-qr').innerHTML,
                canvas_qr_dataurl = document.getElementsByTagName('canvas')[0].toDataURL(),
                canvas_string = '<canvas class="qrcode" height="512" width="512"></canvas>',
                popupWin = window.open('', '_blank',
                    'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);

            printContents = printContents.replace(canvas_string, '<img src="' + canvas_qr_dataurl + '">');

            popupWin.document.open();
            popupWin.document.write('<html><head><base href="/"><title></title>' +
                '<link href="assets/print/print_qr.min.css" rel="stylesheet"/></head>' +
                '<body onload="window.print();window.close();">' + printContents + '</body></html>');
            popupWin.document.close();
          };

          popup.onCopyLink = function() {
            $scope.modals.FeedbackSources.close();
          };

          popup.onCancelClick = function() {
            $scope.modals.FeedbackSources.close();
          };
        }
      });
    };

    $scope.createNewFeedbackSource = function() {
      if (canCreateSource) {
        openCannotCreateModal();
      } else {
        $location.path('/feedback/sources/create');
      }
    };

    function openCannotCreateModal(callback) {
      $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'app/templates/modal.cannot-create-feedback-source.html',
        controllerAs: 'modal',
        controller: function($uibModalInstance) {
          var popup = this;
          popup.close = function() {
            $uibModalInstance.close();
            if (callback && typeof callback === 'function') {
              callback();
            }
          };

          popup.goToTariffChange = function() {
            $uibModalInstance.close();
            $location.path('/tariff');
            $location.search('isChangeTariff', 1);
          };

          popup.goToSupport = function() {
            $uibModalInstance.close();
            $location.path('/support');
          };
        }
      });
    }

    $rootScope.$watch('L_LIST', function(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        $scope.data.filtersList = angular.copy($rootScope.L_LIST);

        if ($rootScope.ENV.filters.feedback_source && $rootScope.ENV.filters.feedback_source.filter &&
            $rootScope.ENV.filters.feedback_source.filter.id !== '0') {
          $scope.data.currentFilter = $rootScope.ENV.filters.feedback_source.filter;
        } else {
          for (var i in $scope.data.filtersList)
            if ($scope.data.filtersList[i].id === '0') {
              $scope.data.currentFilter = $scope.data.filtersList[i];
            } else {
              $scope.data.currentFilter = getFirstActive($scope.data.filtersList);
            }
        }

        $scope.data.currentFilter.id;
      }
    });

    $scope.$watch('data.currentFilter', function(newValue, oldValue) {
      if (newValue) {
        var l = $rootScope.ENV.filters.feedback_source;
        if (l)
          l.filter = newValue;
        else
          l = {filter: newValue};

        $rootScope.ENV.filters.feedback_source = l;
        $rootScope.storeENV();

        _doShow();
      }
    }, true);
  }
})();
